import { ChatHeader } from "./ChatHeader";
import { MessageList } from "./MessageList";
import { Composer } from "./Composer";
import { escalationView } from "../store";

export function ChatPanel() {
  return (
    <>
      <ChatHeader />
      <MessageList />
      <Composer />
      <div class="ic-footer">
        Vil du heller skrive til oss?{" "}
        <button class="ic-link" onClick={() => (escalationView.value = true)}>
          Send oss en e-post
        </button>
      </div>
    </>
  );
}
